import { render, staticRenderFns } from "./productionLicense.vue?vue&type=template&id=934b0c2e&scoped=true"
import script from "./productionLicense.vue?vue&type=script&lang=js"
export * from "./productionLicense.vue?vue&type=script&lang=js"
import style0 from "./productionLicense.vue?vue&type=style&index=0&id=934b0c2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "934b0c2e",
  null
  
)

export default component.exports